export const MainUrls = {
  Root: '/',
  Reservation: '/patient/reservation',
  Mypage: '/patient/mypage',
  QRCode: '/patient/top/qrcode',
  Facilities: '/patient/facilities',
  MedicalHealthInformation: '/patient/medical-health-information',
  Notification: '/patient/notifications/facilities'
};
